import {putMethod} from '~/api'

async function put(request) {
    return await putMethod('/api/updatePackagePrice', request)
}

export {put}
